<template>
  <div class="sidebar-logo-container collapse">
    <div key="collapse" class="sidebar-logo-link">
      <!-- <img src="@/assets/defaultLogo.png" class="sidebar-logo"> -->
      <h3
        class="sidebar-title"
        style="color: #3976f6; font-size: 18px; font-weight: 600;"
      >PRIME</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 100%;
      height: auto;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #3976f6;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
